module.exports = __webpack_public_path__ + "static/media/mulher_r1_c9.68bf3fa1.jpg";